import React from 'react';
import {resolveColor} from '../../../utils/colors';

const Key = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 14 14" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.3333 1.66667L7.13333 6.86667M10.6 3.4L12.3333 5.13333M6.86667 7.13333C8.07822 8.34489 8.07822 10.3089 6.86667 11.5204C5.65511 12.732 3.69111 12.732 2.47956 11.5204C1.268 10.3089 1.268 8.34489 2.47956 7.13333C3.69111 5.92178 5.65511 5.92178 6.86667 7.13333Z"
                stroke={resolveColor(color) || '#A7A7A8'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Key;
